import { Button, styled, Grid } from "@mui/material";
import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import useLocales from "../../hooks/useLocales";
import IsSubmittingButton from "./IsSubmittingButton";

interface ICreateButton {
  disabled: boolean;
}

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  fontSize: 16,
  padding: "6px 12px",
  lineHeight: 1.5,
  position: "relative",
  height: "50px",
  bacgroundColor: "#0060aa",
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
  },
});

const CreateButton: FC<ICreateButton> = ({ disabled }) => {
  const { translate } = useLocales();
  const formik: any = useFormikContext();
  let [, setPrompt] = useState<boolean>(formik.dirty);
  const [, setSuccess] = useState<boolean>(false);

  useEffect(() => {
    setPrompt(formik.dirty);
    if (disabled) setPrompt(false);
    if (formik.isSubmitting) {
      setSuccess(false);
    } else {
      setSuccess(true);
    }
  }, [formik.dirty, disabled, formik.isSubmitting]);

  return (
    <Grid container justifyContent="center">
      {formik.isSubmitting ? (
        <IsSubmittingButton />
      ) : (
        <BootstrapButton
          variant="contained"
          id="saveButton"
          size="large"
          type="submit"
          style={{ minWidth: "200px", backgroundColor: "##0060aa" }}
          disabled={formik.isSubmitting}
        >
          {translate("actions.save")}
        </BootstrapButton>
      )}
    </Grid>
  );
};
export default CreateButton;
